import React from "react";
import { Container } from "react-bootstrap";
import Banner from "../Components/Banner";
import team1 from "../Assets/Images/team/team1.jpeg";
import team2 from "../Assets/Images/team/team2.jpg";
import team3 from "../Assets/Images/team/team3.jpg";
import team4 from "../Assets/Images/team/team4.jpg";
import team5 from "../Assets/Images/team/team5.jpg";
import team6 from "../Assets/Images/team/team6.jpg";
import team9 from "../Assets/Images/team/loice.jpeg";
import team7 from "../Assets/Images/team/team7.jpg";
import team8 from "../Assets/Images/team/team8.jpg";
import icon1 from "../Assets/Images/icon1.svg";
import icon2 from "../Assets/Images/icon2.svg";
import icon3 from "../Assets/Images/icon3.svg";
import img1 from "../Assets/Images/59-min.jpg";
import img2 from "../Assets/Images/91-min.jpg";
import img3 from "../Assets/Images/102-min.jpg";
import aboutBan from "../Assets/Images/leaderBan.png";
import { Link } from "react-router-dom";
import { TestimonialV2 } from "../Components/TestimonialV2";
import { PageMetaTitle } from "../Components/PageMetaTitle";
import { ourTeamMeta } from "../services/metaTags";

export const OurLeadership = () => {
  var bannerContent = {
    title: "<h1>Meet the IG-Smart Team</h1>",
    cardTitle: "Driving Innovation for a Safe & Secure Digital World",
    cardPara:
      "At IG-Smart Ltd, our success story is not just about our services; it's about the dedicated and diverse team behind them. Established in 2009, we've assembled a multidisciplinary group of experts who share our passion for positive global change and sustainable development. Our mission is to empower socially responsible organisations to navigate the digital landscape securely, lawfully, and responsibly. Meet the brilliant minds that make IG-Smart the trailblazing consultancy it is today",
  };

  return (
    <>
    <PageMetaTitle data={ourTeamMeta}/>
      <Banner bannerCnt={bannerContent} banImg={aboutBan} />
      <section className="about7-team sec-padding">
        <Container>
          <div className="leadership-team">
            <h2 className="sec-heading mb-0">Our People</h2>
            <p className="sub-heading mb-4">
              Our team comprises multidisciplinary data privacy, cyber security,
              clinical safety, digital innovation, & resourcing experts.
            </p>
            <div className="leader-card-wpr">
              <Link to={"/team-detail/michael"} className="leader-card">
                <div className="leader-profile">
                  <div className="leader-profile-img">
                    <img  loading="lazy"  width="" height=""   alt="team1" src={team1} />
                  </div>
                  <div className="leader-details">
                    <h5>Michael Abtar</h5>
                    <h6 className="mb-0">
                      CEO and Founder of Award-Winning Data Privacy
                    </h6>
                    <h6 className="leader-ser">
                    Strategic Board & Government Advisor | International Keynote Speaker | Visionary Team Leader
                    </h6>
                    <div className="about7-social-icons">
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon1img" src={icon1} />
                      </a>
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon12img" src={icon2} />
                      </a>
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon13img" src={icon3} />
                      </a>
                    </div>
                  </div>
                </div>
              </Link>

              <Link to="/team-detail/claire" className="leader-card">
                <div className="leader-profile">
                  <div className="leader-profile-img">
                    <img  loading="lazy"  width="" height=""   alt="team8" src={team8} />
                  </div>
                  <div className="leader-details">
                    <h5>Claire Griffin</h5>
                    <h6 className="mb-0">BA (Hons)</h6>
                    <h6 className="leader-ser">
                    Talent & Team Wellness Partner
                    </h6>
                    <div className="about7-social-icons">
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon11img" src={icon1} />
                      </a>
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon122img" src={icon2} />
                      </a>
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon134img" src={icon3} />
                      </a>
                    </div>
                  </div>
                </div>
              </Link>

              <Link to="/team-detail/bright" className="leader-card">
                <div className="leader-profile">
                  <div className="leader-profile-img">
                    <img  loading="lazy"  width="" height=""   alt="team7" src={team7} />
                  </div>
                  <div className="leader-details">
                    <h5>Dr. Bright G. Mawudor</h5>
                    <h6 className="mb-0">PhD</h6>
                    <h6 className="leader-ser">
                      Senior Cyber Security Consultant
                    </h6>
                    <div className="about7-social-icons">
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon1img" src={icon1} />
                      </a>
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon2img" src={icon2} />
                      </a>
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon3img" src={icon3} />
                      </a>
                    </div>
                  </div>
                </div>
              </Link>

              <Link to="/team-detail/shaista" className="leader-card">
                <div className="leader-profile">
                  <div className="leader-profile-img">
                    <img  loading="lazy"  width="" height=""   alt="profile1img" src={team3} />
                  </div>
                  <div className="leader-details">
                    <h5>Shaista Peart</h5>
                    <h6 className="mb-0">BA (Hons), CIPPE</h6>
                    <h6 className="leader-ser">
                    Senior Data Protection & Privacy Professional | Healthcare Information Governance Specialist
                    </h6>
                    <div className="about7-social-icons">
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon1siimg" src={icon1} />
                      </a>
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon1siimg1" src={icon2} />
                      </a>
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon1siimg3" src={icon3} />
                      </a>
                    </div>
                  </div>
                </div>
              </Link>

              <Link to="/team-detail/ashantel" className="leader-card">
                <div className="leader-profile">
                  <div className="leader-profile-img">
                    <img  loading="lazy"  width="" height=""   alt="team6" src={team6} />
                  </div>
                  <div className="leader-details">
                    <h5>Ashantel Lachhani</h5>
                    <h6 className="mb-0">LLB (Hons) CIPP/E CIPM FIP</h6>
                    <h6 className="leader-ser">
                      Data Protection Luminary | Legal & Compliance Expert |
                      Privacy Advocate
                    </h6>
                    <div className="about7-social-icons">
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon1" src={icon1} />
                      </a>
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon2" src={icon2} />
                      </a>
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon3" src={icon3} />
                      </a>
                    </div>
                  </div>
                </div>
              </Link>

              <Link to="/team-detail/himanshu" className="leader-card">
                <div className="leader-profile">
                  <div className="leader-profile-img">
                    <img  loading="lazy"  width="" height=""   alt="team4" src={team4} />
                  </div>
                  <div className="leader-details">
                    <h5>Himanshu Desai</h5>
                    <h6 className="mb-0">MSc, MBA</h6>
                    <h6 className="leader-ser">
                      Health Informatics Professional | Strategic Leader |
                      Healthcare Transformer
                    </h6>
                    <div className="about7-social-icons">
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon1" src={icon1} />
                      </a>
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon2" src={icon2} />
                      </a>
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon3" src={icon3} />
                      </a>
                    </div>
                  </div>
                </div>
              </Link>

              <Link to="/team-detail/loice" className="leader-card">
                <div className="leader-profile">
                  <div className="leader-profile-img">
                    <img  loading="lazy"  width="" height=""   alt="team9" src={team9} />
                  </div>
                  <div className="leader-details">
                    <h5>Loice Kerubo Nyaribo</h5>
                    <h6 className="leader-ser">
                      Kenyan-Qualified Advocate | Technology, Media, and
                      Telecommunications Law
                    </h6>
                    <div className="about7-social-icons">
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon1" src={icon1} />
                      </a>
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon2" src={icon2} />
                      </a>
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon3" src={icon3} />
                      </a>
                    </div>
                  </div>
                </div>
              </Link>

              <Link to="/team-detail/marynelle" className="leader-card">
                <div className="leader-profile">
                  <div className="leader-profile-img">
                    <img  loading="lazy"  width="" height=""   alt="team2" src={team2} />
                  </div>
                  <div className="leader-details">
                    <h5>Marynelle Li</h5>
                    <h6 className="leader-ser">
                      Executive Assistant & Marketing Coordinator
                    </h6>
                    <div className="about7-social-icons">
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon1" src={icon1} />
                      </a>
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon2" src={icon2} />
                      </a>
                      <a href="">
                        <img  loading="lazy"  width="" height=""   alt="icon3" src={icon3} />
                      </a>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </Container>
      </section>
      <section className="sec-padding bg-light">
        <div className="container">
          <div className="complex-chng-des chng-des-md content_card">
            <div className="cmpx-img-card simple_Img team-img">
              <img  loading="lazy"  width="" height=""   src={img1} className="img-fluid cover" alt="icon3img" />
            </div>
            <div className="cmpx-chng-des">
              <div
                className="ltd-case-description custom-list"
                style={{ gap: 0 }}
              >
                <h2 className="mb-2">Our Collaborative Approach </h2>
                <p>
                  At IG-Smart Ltd, we believe that true innovation and
                  problem-solving are achieved through collaboration. Our team
                  is a blend of lawyers, data protection officers,
                  technologists, cybersecurity professionals, clinical safety
                  experts, and health informatics specialists. With a wealth of
                  qualifications, including MBA's, MSc's, Post Graduate Diplomas
                  in Law, ISO 27001 certifications, and Certified Ethical
                  Hackers, we approach challenges from every angle.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sec-padding ">
        <div className="container">
          <div className="complex-chng-des chng-des-md content_card reverse">
            <div className="cmpx-chng-des">
              <div
                className="ltd-case-description custom-list"
                style={{ gap: 0 }}
              >
                <h2 className="mb-2">Diversity Matters</h2>
                <p>
                  Diversity is at the heart of our team. We proudly speak
                  multiple languages, including English, French, Arabic,
                  Gujarati, Urdu, Pilipino, Swahili, Yoruba, Ibo, and Twi. Our
                  diversity fuels creativity and enables us to connect with
                  clients worldwide.
                </p>
              </div>
            </div>
            <div className="cmpx-img-card simple_Img team-img">
              <img  loading="lazy"  width="" height=""   src={img2} className="img-fluid cover" alt="img-fluid" />
            </div>
          </div>
        </div>
      </section>

      <section className="sec-padding bg-light">
        <div className="container">
          <div className="complex-chng-des chng-des-md content_card">
            <div className="cmpx-img-card simple_Img team-img">
              <img  loading="lazy"  width="" height=""   src={img3} className="img-fluid cover" alt="simple_Img1" />
            </div>
            <div className="cmpx-chng-des">
              <div
                className="ltd-case-description custom-list"
                style={{ gap: 0 }}
              >
                <h2 className="mb-2">Join Us on the Journey</h2>
                <p>
                  As a team, we've earned accolades such as the Best Cyber
                  Security Consultancy (2019-2023) and GDPR Consultancy of the
                  Year (2020-2023). Our commitment to knowledge leadership,
                  innovation, and excellence drives us forward.
                </p>
                <p>
                  Partner with IG-Smart Ltd for a smarter, safer, and more
                  sustainable digital world. Visit our website or call{" "}
                  <a href="tel:+44 0 20 7167 4268">+44 0 20 7167 4268</a>. For
                  inquiries, reach out to{" "}
                  <a href="mailto:info@ig-smart.com">info@ig-smart.com</a>, and
                  let's embark on a journey toward digital transformation and
                  responsible data stewardship together.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <TestimonialV2 />
    </>
  );
};
